import React from 'react'
import styled from 'styled-components'
import { useSysTheme } from 'hooks/useUiState'
import { getFloatNumberInfo } from '../utils'

const StarContainer = styled.div`
  display: flex;
  gap: 4px;
`

// clip-path generate by: https://bennettfeely.com/clippy/
const SolidStar = styled.div<{ color?: string }>`
  width: 14px;
  height: 14px;
  background-color: ${({ color }) => color};
  clip-path: polygon(
    50% 0%,
    65% 33%,
    100% 38%,
    75% 64%,
    81% 100%,
    50% 83%,
    19% 100%,
    25% 64%,
    0 38%,
    34% 33%
  );
`

const LinearedStar = styled(SolidStar)<{
  percent: number
  fillColor: string
  bgColor: string
}>`
  background: linear-gradient(
    to right,
    ${({ fillColor }) => fillColor} 0 ${({ percent }) => percent}%,
    ${({ bgColor }) => bgColor} ${({ percent }) => percent}% 100%
  );
`

const StarRating = ({ value, maxValue }: { value: number; maxValue: number }) => {
  const theme = useSysTheme()
  const { floorValue, pointValue } = getFloatNumberInfo(value)

  const hasPoint = pointValue !== 0

  const filledStars = Array(floorValue > 0 ? floorValue : 0).fill(0)
  const emptyStars = Array(maxValue - filledStars.length - (hasPoint ? 1 : 0)).fill(0)

  return (
    <StarContainer>
      {filledStars.map((_, index) => (
        /* eslint-disable-next-line react/no-array-index-key */
        <SolidStar key={index} color={theme.semantic.middle.default} />
      ))}
      {hasPoint && (
        <LinearedStar
          percent={pointValue * 10}
          fillColor={theme.semantic.middle.default}
          bgColor={theme.common.divider[100]}
        />
      )}
      {emptyStars.map((_, index) => (
        /* eslint-disable-next-line react/no-array-index-key */
        <SolidStar key={index} color={theme.common.divider[100]} />
      ))}
    </StarContainer>
  )
}

export default StarRating
